import API from "@vahak/core/dist/_services/const";
import { useVahakMutationQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";
import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";
import { QueryNames } from "@vahak/core/dist/_services/hooks/queryNames";
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types/api-error-response-type";

interface Params {
    lorry_id?: number;
    load_id?: number;
    bid_id?: number;
    ticket_id?: number;
    mpc_name?: string;
    agent?: string; //"91_____";
    customers?: [string];
    screen_name?: string;
}

interface Response {
    data: {
        mpc_uuid: string;
        mpc_name: string;
        users: {
            customers: {
                phone: string;
                call_uuid: string;
            }[];
        };
    };
}

export const useConferenceCall = () => {
    const { POST } = useVahakHttpClient();

    const method = (data: Params) => {
        return POST<Params, Response>(API.CONFERENCE_INITIATE, data);
    };

    return useVahakMutationQuery<Response, ApiErrorResponseType, Params>(QueryNames.call.conferenceInitiate, method);
};

interface CallKickParams {
    mpc_name: string;
    call_uuid: string;
}

export const useConferenceCallKick = () => {
    const { POST } = useVahakHttpClient();

    const method = (data: CallKickParams) => {
        return POST<CallKickParams, Response>(API.CONFERENCE_KICKOUT, data);
    };

    return useVahakMutationQuery<Response, ApiErrorResponseType, CallKickParams>(
        QueryNames.call.conferenceKick,
        method
    );
};

interface CallEndParams {
    mpc_name: string;
}

export const useConferenceCallEnd = () => {
    const { POST } = useVahakHttpClient();

    const method = (data: CallEndParams) => {
        return POST<CallEndParams, Response>(API.CONFERENCE_END, data);
    };
    return useVahakMutationQuery<Response, ApiErrorResponseType, CallEndParams>(QueryNames.call.conferenceEnd, method);
};
